module.exports = __webpack_public_path__ + "static/media/instagram.e40b5be1.svg";